import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
import _JSON$stringify from "@babel/runtime-corejs3/core-js/json/stringify";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import _Object$values from "@babel/runtime-corejs3/core-js/object/values";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import GenericModal from "@Shared/components/modals/generic-modal.vue";
import InlinePrompt from "@Shared/components/general/inline-prompt.vue";
import vSelectField from "@Shared/components/form-elements/fields/v-select-field.vue";
import { defineComponent } from "@vue/composition-api";
import MaterialInput from "@Shared/components/inputs/material-input.vue";
import ChecklistComponent from "@Shared/components/checklist/checklist";
import SaveChecklistModal from "./save-checklist-modal";
export default defineComponent({
  name: "ChecklistTemplateEditor",
  components: {
    GenericModal,
    InlinePrompt,
    vSelectField,
    MaterialInput,
    ChecklistComponent,
    SaveChecklistModal
  },
  props: {
    checklistTemplates: {
      type: Object,
      required: true
    },
    initialTemplate: {
      type: Object,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      selectedTemplateId: null,
      selectedName: "",
      currentTemplate: this.initialTemplate ? _objectSpread({}, this.initialTemplate) : null
    };
  },
  computed: {
    checklistNames() {
      const templates = [];
      for (const id in this.checklistTemplates) {
        templates.push({
          value: this.checklistTemplates[id].title,
          label: this.checklistTemplates[id].title
        });
      }
      return templates;
    },
    difference() {
      if (!this.currentTemplate || !this.initialTemplate) return false;
      return this.currentTemplate.title !== this.initialTemplate.title || _JSON$stringify(this.currentTemplate.checklist) !== _JSON$stringify(this.initialTemplate.checklist);
    },
    uniqueName() {
      for (const id in this.checklistTemplates) {
        if (this.checklistTemplates[id].title === this.currentTemplate.title) {
          return false;
        }
      }
      return true;
    },
    isNotEmpty() {
      return this.currentTemplate.checklist.length > 0;
    }
  },
  methods: {
    handleHidden() {
      this.selectedTemplateId = null;
      this.selectedName = "";
      this.currentTemplate = null;
    },
    selectTemplate(selectedOption) {
      var _context;
      const templateTitle = selectedOption.value;
      const selectedTemplate = _findInstanceProperty(_context = _Object$values(this.checklistTemplates)).call(_context, template => template.title === templateTitle);
      this.selectedTemplateId = selectedTemplate.id;
      this.currentTemplate = _objectSpread({}, selectedTemplate);
      this.selectedName = templateTitle;
    },
    loadTemplate() {
      this.$hideModal();
      this.$emit("select", this.currentTemplate);
    },
    deleteTemplate(templateId) {
      this.$emit("delete", templateId);
    },
    show() {
      this.$refs.modal.show();
      this.currentTemplate = this.initialTemplate ? _objectSpread({}, this.initialTemplate) : null;
    },
    hide() {
      this.$refs.modal.hide();
      this.selectedTemplateId = null;
      this.selectedName = "";
      this.currentTemplate = null;
    },
    clear() {
      this.selectedTemplateId = null;
      this.selectedName = "";
    },
    handleUpdate({
      checklist
    }) {
      this.currentTemplate = _objectSpread(_objectSpread({}, this.currentTemplate), {}, {
        checklist
      });
    },
    handleDeleteTemplate() {
      this.$emit("delete", this.selectedTemplateId);
      this.selectedTemplateId = null;
      this.selectedName = "";
      this.currentTemplate = {
        title: "",
        checklist: []
      };
    },
    openSaveModal() {
      this.$refs.saveChecklistModal.$showModal();
    },
    saveNewTemplate(templateName) {
      this.currentTemplate.title = templateName;
      this.selectedName = templateName;
      this.$emit("add", {
        title: templateName,
        checklist: this.currentTemplate.checklist
      });
    }
  }
});